/**
 * Pausa de impacto (F68, guia §21): quando o próprio golpe acerta, as animações (bonecos e criaturas)
 * congelam 40 a 60 ms. Só desenho local: a simulação, a câmera e a rede seguem. Golpes seguidos não somam
 * (fica o fim mais distante), e há um intervalo mínimo para não travar num combo rápido.
 */
export class HitStop {
  private until = -Infinity;
  private next = -Infinity;

  /** Pede a pausa de `ms` a partir de `now` (ms). */
  trigger(now: number, ms: number): void {
    if (now < this.next) return;
    this.until = Math.max(this.until, now + ms);
    this.next = now + ms + HIT_STOP.gapMs;
  }

  /** Fator do tempo das animações agora: 0 na pausa, 1 fora dela. */
  scale(now: number): number {
    return now < this.until ? 0 : 1;
  }
}

/** Duração por peso do golpe e o intervalo mínimo entre pausas (ms). */
export const HIT_STOP = { normalMs: 40, heavyMs: 60, gapMs: 90 } as const;
